// src/screens/Admin/MerchantManager.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api';
import './MerchantManager.css';

import backIcon from '../../assets/backspace-icon.png';

function MerchantManager({ user }) {
  const navigate = useNavigate();
  const [merchants, setMerchants] = useState([]);
  const [statusFilter, setStatusFilter] = useState('all');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMerchants = async () => {
      try {
        const res = await api.get('/admin/merchants', {
          params: statusFilter === 'all' ? {} : { status: statusFilter },
        });

        setMerchants(res.data.merchants || []);
      } catch (err) {
        console.error('❌ Failed to fetch merchants:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMerchants();
  }, [statusFilter]);

  const filteredMerchants = merchants;

  const formatDate = (dateStr) => {
    if (!dateStr) return 'N/A';
    const date = new Date(dateStr);
    return date.toLocaleDateString() + (dateStr.includes('T') ? ` ${date.toLocaleTimeString()}` : '');
  };

  return (
    <div className="merchantmanager-container">
      <div className="merchantmanager-topbar">
        <img
          src={backIcon}
          alt="Back"
          className="merchantmanager-back-icon"
          onClick={() => navigate('/admin')}
        />
        <h2>Merchant Management</h2>
      </div>

      <div className="merchantmanager-filters">
        <button
          onClick={() => setStatusFilter('all')}
          className={statusFilter === 'all' ? 'active' : ''}
        >
          All
        </button>
        <button
          onClick={() => setStatusFilter('active')}
          className={statusFilter === 'active' ? 'active' : ''}
        >
          Active
        </button>
        <button
          onClick={() => setStatusFilter('pending')}
          className={statusFilter === 'pending' ? 'active' : ''}
        >
          Pending
        </button>
        <button
          onClick={() => setStatusFilter('approved')}
          className={statusFilter === 'approved' ? 'active' : ''}
        >
          Approved
        </button>
        <button
          onClick={() => setStatusFilter('rejected')}
          className={statusFilter === 'rejected' ? 'active' : ''}
        >
          Rejected
        </button>
        <button
          onClick={() => setStatusFilter('suspended')}
          className={statusFilter === 'suspended' ? 'active' : ''}
        >
          Suspended
        </button>
      </div>

      <div className="merchantmanager-content">
        {loading ? (
          <p className="merchantmanager-loading">Loading merchants...</p>
        ) : filteredMerchants.length === 0 ? (
          <p className="merchantmanager-empty">✅ No merchants in this category.</p>
        ) : (
          filteredMerchants.map((merchant) => {
            const isActive = merchant.status === 'approved' && merchant.isMerchant;
            const listingStatus = isActive ? 'Active' : merchant.status === 'approved' ? 'Inactive' : '-';

            return (
              <div
                key={merchant._id}
                className="merchantmanager-card"
                onClick={() => navigate(`/admin/merchants/${merchant._id}`)}
              >
                <p><strong>Username:</strong> {merchant.username}</p>
                <p><strong>Business Name:</strong> {merchant.storeName || 'N/A'}</p>

                <p>
                  <strong>Status:</strong>{' '}
                  <span className={`merchant-status-badge ${merchant.status}`}>
                    {merchant.status ? merchant.status.charAt(0).toUpperCase() + merchant.status.slice(1) : 'N/A'}
                  </span>
                </p>

                {merchant.status === 'approved' && (
                  <p>
                    <strong>Listing:</strong>{' '}
                    <span className={`merchant-listing-status ${isActive ? 'active' : 'inactive'}`}>
                      {listingStatus}
                    </span>
                  </p>
                )}

                {merchant.merchantPaidUntil && (
                  <p>
                    <strong>Subscription Expires:</strong>{' '}
                    {formatDate(merchant.merchantPaidUntil)}
                  </p>
                )}

                <p>
                  <strong>Application Date:</strong>{' '}
                  {merchant.applicationDate ? formatDate(merchant.applicationDate) : 'N/A'}
                </p>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
}

export default MerchantManager;
